module.exports = __webpack_public_path__ + "img/kpbj.99e3b307.png";